const ES = navigator.language?.startsWith('es')

// The card around a chart, found by the chart's root id (the chart title is not a stable target)
const chartCard = (rootID) => document.getElementById(rootID)?.closest('.MuiCard-root')

// The card around the table whose title starts with the given text
function tableCard(title) {
	const el = [...document.querySelectorAll('.MuiCardHeader-root, .MuiTypography-root')]
		.find(e => e.textContent.trim().startsWith(title))
	return el?.closest('.MuiCard-root, .MuiPaper-root')
}


export const TOUR_STEPS = [
	{
		type: 'intro',
		icon: 'house-chimney',
		title: ES ? 'Bienvenido al Panel Principal' : 'Welcome to the Dashboard',
		description: ES
			? 'Este es tu centro de control. Aquí puedes ver la actividad de búsquedas, la distribución por sitio, tendencias y el estado de los informes de un vistazo. Te lo enseño.'
			: 'This is your command center. Here you can see search activity, site distribution, trends, and report statuses at a glance. Let me show you around.',
	},
	{
		type: 'field',
		findTarget: () => document.querySelector('[data-tour-id="tour-activity-cards"]'),
		icon: 'chart-simple',
		title: ES ? 'Tarjetas de Actividad' : 'Activity Cards',
		description: ES
			? 'Resumen rápido de tu volumen de búsquedas — hoy, esta semana y este mes. Controla las tendencias de uso en tiempo real de un vistazo.'
			: 'Quick snapshot of your search volume — today, this week, and this month. Track real-time usage trends at a glance.',
		example: ES
			? 'Today: 42 | This Week: 318 | This Month: 1.204'
			: 'Today: 42 | This Week: 318 | This Month: 1,204',
	},
	{
		type: 'field',
		findTarget: () => chartCard('SearchAnalyticsPieChart'),
		icon: 'chart-pie',
		title: ES ? 'Búsquedas por Sitio' : 'Searches per Site',
		description: ES
			? 'Consulta cómo se distribuyen tus búsquedas entre webs de alquiler y metabuscadores. Identifica qué proveedores reciben más atención.'
			: 'See how your searches are distributed across rental websites and metasearch engines. Identify which providers get the most attention.',
		example: ES
			? 'PriceFly 28% | RentalSpot 22% | SwiftFleet 15%'
			: 'PriceFly 28% | RentalSpot 22% | SwiftFleet 15%',
	},
	{
		type: 'field',
		findTarget: () => chartCard('SearchAnalyticsBarChart'),
		icon: 'chart-column',
		title: ES ? 'Comparativa Mensual' : 'Monthly Comparison',
		description: ES
			? 'Compara el volumen de búsquedas de este mes con el anterior, día a día. Detecta patrones estacionales y picos de actividad.'
			: 'Compare this month\'s search volume against the previous month, day by day. Spot seasonal patterns and activity spikes.',
		example: ES
			? 'Azul = Mes actual | Turquesa = Mes anterior'
			: 'Blue = Current Month | Turquoise = Previous Month',
	},
	{
		type: 'field',
		findTarget: () => tableCard('Summary of searches'),
		icon: 'table-list',
		title: ES ? 'Tabla Resumen de Búsquedas' : 'Search Summary Table',
		description: ES
			? 'Desglose detallado de búsquedas por fecha, usuario y sitio. Úsalo para auditar la actividad del equipo e identificar a los principales contribuidores.'
			: 'Detailed breakdown of searches by date, user, and site. Use this to audit team activity and identify top contributors.',
	},
	{
		type: 'field',
		findTarget: () => document.querySelector('[data-tour-id="tour-summary-view"]'),
		icon: 'toggle-on',
		title: ES ? 'Selector de Vista' : 'View Toggle',
		description: ES
			? 'Alterna entre las vistas «Date & User» y «User & Site» para analizar los datos de búsqueda desde diferentes perspectivas.'
			: 'Switch between "Date & User" and "User & Site" views to analyze search data from different perspectives.',
		example: ES
			? 'User & Site = por usuario y web | Date & User = por día y usuario'
			: 'User & Site = per user and website | Date & User = per day and user',
	},
	{
		type: 'field',
		findTarget: () => tableCard('Last Report Executions'),
		icon: 'file-lines',
		title: ES ? 'Ejecuciones de Informes' : 'Report Executions',
		description: ES
			? 'Monitoriza el estado de tus últimos informes automatizados. Comprueba cuáles se ejecutaron correctamente y cuáles necesitan atención.'
			: 'Monitor the status of your latest automated reports. See which reports ran successfully and which need attention.',
	},
	{
		type: 'outro',
		icon: 'star',
		title: ES ? '¡Todo Listo!' : "You're All Set!",
		description: ES
			? 'Explora la barra lateral para acceder a Búsquedas en Tiempo Real, Historial y Analizadores. Cada sección tiene su propio Tour Virtual para ayudarte a empezar.'
			: 'Explore the sidebar to access Real-Time Searches, History, and Analyzers. Each section has its own Virtual Tour to help you get started.',
	},
]
